export default "__VITE_ASSET__CaI1gOXi__"